<template>
  <div class="outlet page">
    <div class="page-title">
      <span>{{$t('revenue_report')}}</span>
      <div class="choose-currency">
        <select v-if="$route.name !== 'global'" name="currency" v-model="currency" @change="selectCurrency">
          <option v-if="getStoreConfig() && !isNotUseStoreCurrency(getStoreConfig().currency)" :value="null">{{
            getStoreConfig().currency }}</option>
          <option v-for="rate in (getCurrencyRates)" :value="rate.toCurrency" :key="rate.id">
            {{ rate.toCurrency }}
          </option>
        </select>
      </div>
    </div>
    <UiFilterbar @onDefaultFilter="onDefaultFilter" @onFilterDay="onDefaultFilter" @onChangeOutlet="onChangeOutlet"
      @onChangeOrderStatus="onChangeOrderStatus" :disableCompareDate="false" :queryMode="this.query.mode" />
    <UiReportList :reportList="reportList" />
    <UiCheckboxRevenue @onChangeOnlyPaid="onChangeOnlyPaid" />
    <UiHighCharts :options="prepareChartOptions()" :noConvertDate="true"
      :loading="loading || !(report && report.items && typeof (report.items) === 'object')"></UiHighCharts>
    <UiTableReportCommon :report="report" :colsData="colsData" :key="tableKey" />
  </div>
</template>

<script>
import * as _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
// import currencyFormatter from 'currency-formatter'
import formatNum from 'format-num'
import { getItemByLocalStorage, setLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import UiHighCharts from '@/components/UiHighCharts'
import UiCheckboxRevenue from '@/components/UiCheckboxRevenue'
import UiFilterbar from '@/components/filterBar/UiFilterbar'
import UiReportList from '@/components/UiReportList'
import UiTableReportCommon from '@/components/UiTableReportCommon'
import reportType from '@/config/reportType'
import reportListData from '@/constants/reportList'
import i18n from '@/i18n'
export default {
  name: 'PaymentMethodPage',
  components: {
    UiFilterbar,
    UiHighCharts,
    UiReportList,
    UiTableReportCommon,
    UiCheckboxRevenue
  },
  data() {
    const timeZone = Number.isInteger(Number(new Date().getTimezoneOffset()) / 60) ? (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60}`.padStart(2, 0)}:00` : `-${Number(new Date().getTimezoneOffset()) / 60}:00`) : (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Math.trunc(Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60)}`.padStart(2, 0)}:30` : `-${Math.trunc(Number(new Date().getTimezoneOffset()) / 60)}:30`)
    return {
      currency: null,
      day: {},
      query: {
        page: 1,
        limit: 100,
        mode: 'DATE',
        outletIds: null,
        registerIds: null,
        timeZone,
        reportingMode: 'in_store'
      },
      reportList: reportListData.revenue,
      filterType: 'DATE',
      colsData: [],
      tableKey: 0
    }
  },
  computed: {
    ...mapGetters({
      report: 'report/getPaymentReportData',
      cols: 'report/getColsData',
      loading: 'common/loading',
      getCurrencies: 'currency/getCurrencies',
      getCurrencyRates: 'currency/getCurrencyRates'
    }),
    visibleFields() {
      return this.fields.filter(field => field.visible)
    }
  },
  watch: {
    report: function (news, old) {
      if (news != null && news !== old) {
        this.tableKey = Math.random()
        this.colsData = this.cols
      }
    }
  },
  methods: {
    ...mapActions({
      getReport: 'report/getReportDataByStore',
      getCustomStatuses: 'order/getListCustomStatus'
    }),
    selectCurrency() {
      const currencyRate = this.getCurrencyRates.find(rate => rate.toCurrency === this.currency)

      if (currencyRate) {
        const currencySelected = this.getCurrencies.find(currencyItem => this.currency === currencyItem.code)
        const symbol = currencySelected.currency_symbol || this.currency
        var isBaseCurrency = this.getStoreConfig().currency && this.isNotUseStoreCurrency(this.getStoreConfig().currency) && this.currency === this.getStoreConfig().currency
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, { ...currencyRate, symbol, rate: isBaseCurrency ? 1 : currencyRate.rate })
      }

      if (!this.currency && getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
        const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
        const currencySelected = this.getCurrencies.find(currencyItem => storeConfig?.currency === currencyItem.code)
        const symbol = currencySelected.symbol
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, {
          fromCurrency: storeConfig?.currency,
          toCurrency: storeConfig?.currency,
          rate: 1,
          symbol
        })
      }

      this.getReport({
        type: reportType.outlets,
        query: {
          ...this.query,
          ...this.day
        }
      }).then(() => {
        this.colsData = this.cols
        this.tableKey = Math.random()
      })
    },
    getStoreConfig() {
      return getItemByLocalStorage(localStorageKey.STORE_CONFIG)
    },
    onDefaultFilter(day, type, reportingMode, outletIds, registerIds, states) {
      this.day = day
      this.getCustomStatuses()
      if (outletIds) {
        this.query.outletIds = outletIds
        this.query.registerIds = registerIds
      }
      if (reportingMode) {
        this.query.reportingMode = reportingMode
        if (reportingMode === 'online') {
          this.query.outletIds = null
        }
      }
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.outlets,
        query: {
          ...this.query,
          ...day,
          states
        }
      }).then(() => {
        this.colsData = this.cols
        this.tableKey = Math.random()
      })
    },
    onChangeOutlet(reportingMode, outletIds, registerIds, day, type, states) {
      this.day = day
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.outlets,
        query: {
          ...this.query,
          ...day,
          states
        }
      }).then(() => {
        this.colsData = this.cols
        this.tableKey = Math.random()
      })
    },
    onChangeOrderStatus(reportingMode, outletIds, registerIds, day, type, states) {
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.outlets,
        query: {
          ...this.query,
          ...day,
          states
        }
      })
      this.query.showAllOrders = reportingMode !== 'in_store'
      this.getReport({
        type: reportType.outlets,
        query: {
          ...this.query,
          ...day,
          states,
          mode: null,
          timeZone: this.getTimeZone()
        }
      })
    },
    formartDate(date) {
      if (!_.isDate(new Date(date).toString())) return date
      return i18n.d(new Date(moment(date).toDate().toUTCString()), 'short')
    },
    formatTotal(total) {
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
      return `${currentCurrent?.symbol || storeConfig.symbol} ${formatNum((Number(total) * Number(currentCurrent?.rate || '1')).toFixed(2), { maxFraction: 2 })}`
    },
    prepareDataToViewOnTable() {
      const list = {
        title: {},
        items: {}
      }

      this.report.forEach(item => {
        list.title[item.outletName] = item.outletName

        if (list.items[item.outletName] === undefined) {
          list.items[item.outletName] = {}
        }

        list.items[item.outletName][item.createdAt] = item.totalPrice
      })

      return list
    },
    prepareColsToViewOnTable() {
      const cols = {}

      this.report.forEach(item => {
        cols[item.createdAt] = true
      })

      return cols
    },
    prepareChartOptions() {
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
      const dateList = this.report && this.report.items ? Object.keys(this.report.items).map(item => this.formartDate(item)) : []
      let outletList = []
      if (this.report && this.report.items) {
        Object.keys(this.report.items).map(item => {
          outletList = _.union(outletList, Object.keys(this.report.items[item]))
        })
      }
      const valueList = []
      outletList.forEach(payment => {
        const outletData = {
          name: payment,
          data: []
        }
        Object.keys(this.report.items).forEach(item => {
          outletData.data.push(this.report.items[item][payment] ? Number(Number.parseFloat(Number(this.report.items[item][payment] || 0) * Number(currentCurrent?.rate || '1')).toFixed(6)) : 0)
        })
        valueList.push(outletData)
      })
      return {
        chart: {
          type: 'line',
          redraw: true,
          panning: true,
          reflow: false,
          animation: false
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true
            }
          },
          series: {
            pointPadding: 0
          }
        },
        tooltip: {
          enabled: true,
          animation: false,
          valueDecimals: 2,
          valuePrefix: currentCurrent?.symbol || storeConfig.symbol
        },
        series: [
          ...valueList
        ],
        legend: {
          enabled: false
        },
        xAxis: {
          type: 'category',
          categories: dateList,
          min: 0,
          scrollbar: {
            enabled: true
          },
          tickLength: 0
        },
        colors: ['#2caffe', '#544fc5', '#00e272', '#fe6a35', '#6b8abc', '#d568fb', '#2ee0ca', '#fa4b42', '#feb56a', '#91e8e1'],
        yAxis: {
          title: {
            text: ''
          },
          labels: {
            formatter: (value) => `${currentCurrent?.symbol || storeConfig.symbol}${value.value}`
          }
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        }
      }
    },
    isNotUseStoreCurrency(currency) {
      if (currency && currency.length && this.getCurrencyRates && this.getCurrencyRates.length > 0) {
        const existCurrency = this.getCurrencyRates.find(currencyItem => currency === currencyItem.toCurrency)
        return !!existCurrency
      }
      return false
    },
    onChangeOnlyPaid(value) {
      this.getReport({
        type: reportType.outlets,
        query: {
          ...this.query,
          revenueType: value
        }
      }).then(() => {
        this.colsData = this.cols
        this.setCustomizeData(this.visibleFields)
        this.tableKey = Math.random()
      })
    }
  },
  created() {
    if (getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
      this.currency = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY).toCurrency
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding: 0 30px;
}

.page-title {
  font-size: 36px;
  line-height: 49px;
  margin-bottom: 25px;
  display: flex;
  justify-content: space-between;

  select {
    padding: 0 15px;
    margin: 0;
    height: 39px;
    min-width: 140px;
    outline: none;
    border-radius: 4px;
    border: 1px solid #818181;
    background-color: #fff;
  }
}
</style>
